import { render, staticRenderFns } from "./allMaterial.vue?vue&type=template&id=57e09c88&scoped=true"
import script from "./allMaterial.vue?vue&type=script&lang=js"
export * from "./allMaterial.vue?vue&type=script&lang=js"
import style0 from "./allMaterial.vue?vue&type=style&index=0&id=57e09c88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e09c88",
  null
  
)

export default component.exports